<script setup>
import { computed, onMounted, onUnmounted, ref } from 'vue';
import { url } from '@/config/urls';
import { Capacitor } from '@capacitor/core';
import router from '@/router/index.js';
import { useTermsConsentStore } from '@stores/termsConsent';

const emit = defineEmits(['applyBarcodeScan']);

const store = useTermsConsentStore();

const props = defineProps({
  splitSiteCode: {
    type: Number,
    default: null
  }
});

const isConsent = computed(() => store.barcodeScanConsent);
const isNavigatingToPdf = ref(false);

const clickBarcodeScanPdfLink = () => {
  store.setConsent('barcodeScanTerms');
  const platform = Capacitor.getPlatform();

  if (platform === 'ios' || platform === 'android') {
    isNavigatingToPdf.value = true;
    router.push({
      path: '/pdf-viewer/barcode-scan-terms'
      , query: {
        reopenModal: 'barcodeScanApplyModal'
        , returnPath: router.currentRoute.value.path
      }
    });
  } else {
    // 同じウィンドウの新しいタブでPDF表示ページを開く
    window.open('/front/pdf-viewer/barcode-scan-terms', '_blank', 'noopener');
  }
};

const agreeAndReset = () => {
  store.resetConsent('barcodeScanTerms');
  emit('applyBarcodeScan');
};

const onModalHidden = () => {
  if (isNavigatingToPdf.value) {
    isNavigatingToPdf.value = false;
    return;
  }
  store.resetConsent('barcodeScanTerms');
};

onMounted(() => {
  document.getElementById('barcodeScanApplyModal')?.addEventListener('hidden.bs.modal', onModalHidden);
});

onUnmounted(() => {
  document.getElementById('barcodeScanApplyModal')?.removeEventListener('hidden.bs.modal', onModalHidden);
});

</script>

<template>
  <div class="modal com_modal2 fade" id="barcodeScanApplyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-body">
          <img src="/front/assets/common/img/icon_attention1.png" alt="" class="icon_attention1">
          <h3 class="com_fs18 com_strong1 com_center1">ご確認ください</h3>
          <p class="com_fs14 com_center1">バーコードスキャン機能の利用規約をご確認いただき、同意ボタンを押してください。</p>
          <p class="com_fs14 com_center1">
            <a href="#" target="_blank" class="com_link2" @click.prevent="clickBarcodeScanPdfLink">バーコードスキャン機能利用規約
              <img src="/front/assets/common/img/icon_pdf1.png" alt="" class="com_icon_pdf1">
            </a>
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn com_btn1" data-bs-dismiss="modal" :disabled="!isConsent" @click="agreeAndReset">同意する</button>
          <button type="button" class="btn com_btn2" data-bs-dismiss="modal">戻る</button>
        </div>
      </div>
    </div>
  </div>
</template>